import onElementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElementExistRunOnce('.maintenance-records-report-table', () => {
  import('./internal/maintenance-records-report-table').then(
    ({ default: Component }) => Component(),
  );
});

onElementExistRunOnce('.maintenance-records-page-show', () => {
  import('./internal/maintenance-record-show-page').then(
    ({ default: Component }) => Component(),
  );
});
